<template>

  <div class="img">
    <img src="/static/img/contact/contact-banner.png"/>
  </div>
</template>

<script>
  export default{
    name: 'homeContactBanner'
  }
</script>

<style scoped>

  div.img {
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    display: flex;
  }

  div.container {
    padding: 0;
    margin: auto;
    width: auto;
  }

  p {
    font-family: Helvetica-Bold, "Helvetica Bold", Helvetica;
    font-weight: 700;
    font-style: normal;
    font-size: 28px;
    color: rgb(255, 255, 255);
    text-align: center;
    white-space: nowrap;
    line-height: 48px;
    padding: 0;
    margin: 0;
    border-bottom: solid;
    padding-left: 20px;
    padding-right: 20px;
  }

  img {
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// HomeContactBanner.vue?230b4bdc